// extracted by mini-css-extract-plugin
module.exports = {"checkboxGroup":"CheckboxGroupRaw_checkboxGroup__1rL6K","contentBox":"CheckboxGroupRaw_contentBox__360A-"};